import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";

const TooltipWrapper = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  font-size: 12px;
  padding: 6px;
  transform: translate(-50%, -50%);
  font-family: "AllianceNo2-Regular" !important;
`;

const Tooltip = () => {
  const actions = useContext(ActionsContext);
  const [data, setData] = useState(null);
  useEffect(() => {
    return actions.recv("mouse-over-rule", (data) => {
      setData(data);
    });
  }, []);

  if (data === null) {
    return null;
  }

  const { x, y, content } = data;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
      }}
    >
      <TooltipWrapper
        style={{
          position: "absolute",
          width: "auto",
          left: x,
          top: y + 20,
        }}
      >
        {content}
      </TooltipWrapper>
    </div>
  );
};

export default Tooltip;